import React, { useEffect, useState } from 'react'
import { MenuItem, TextField } from '@mui/material'

interface ActiveProps {
  value: any
  onChange: any
  variant?: 'outlined' | 'filled' | 'standard'
  fullWidth?: boolean
  name?: string
  required?: boolean
}

interface ElementoConEstado {
  id: string
  value: string
}

export const ActiveDDL: React.FC<ActiveProps> = ({
  onChange,
  value,
  variant = 'standard',
  fullWidth = false,
  required = false,
  name = 'activeId'
}) => {
  const [hasError, setHasError] = useState<boolean>(false)
  const elementos: ElementoConEstado[] = [
    { id: 'Activo', value: '1' },
    { id: 'Inactivo', value: '0' }
  ]

  const arrElements = elementos.map((option: ElementoConEstado) => (
    <MenuItem key={option.id} value={option.value}>
      {option.id}
    </MenuItem>
  ))

  useEffect(() => {
    if (required && value === -1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  return (
    <TextField
      id={name}
      name={name}
      select
      value={value}
      onChange={onChange}
      variant={variant}
      fullWidth={fullWidth}
      error={hasError}
      helperText={hasError ? 'Seleccionar Opción' : undefined}
    >
      <MenuItem key={-1} value={-1}>
        {'Seleccionar...'}
      </MenuItem>
      {arrElements}
    </TextField>
  )
}
